import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from '@/components/ui/sonner';
import { Header } from '@/components/Header';
import { Hero } from '@/components/Hero';
import { HeroMinimal } from '@/components/HeroMinimal';
import { Services } from '@/components/Services';
import { CoreServices } from '@/components/CoreServices';
import { GoVipExperience } from '@/components/GoVipExperience';
import { ToursPage } from '@/components/ToursPage';
import { Destinations } from '@/components/Destinations';
import { BookingSectionNew } from '@/components/BookingSectionNew';
import { Testimonials } from '@/components/Testimonials';
import { GoogleReviewsSection } from '@/components/GoogleReviewsSection';
import { VehicleShowcase } from '@/components/VehicleShowcase';
import { BottomCTA } from '@/components/BottomCTA';
import { FloatingCTAs } from '@/components/FloatingCTAs';
import { FAQ } from '@/components/FAQ';
import { Footer } from '@/components/Footer';
import { AdminBookings } from '@/components/AdminBookings';
import { AdminMarketing } from '@/components/AdminMarketing';
import { AdminPromos } from '@/components/AdminPromos';
import { FeaturedPromos } from '@/components/FeaturedPromos';
import { ShortLinkRedirect, SHORT_LINKS } from '@/components/ShortLinkRedirect';
import { PrivacyPolicy } from '@/components/PrivacyPolicy';
import { TermsConditions } from '@/components/TermsConditions';
import { CookieConsent } from '@/components/CookieConsent';
import { LanguageSync } from '@/components/LanguageSync';
import { SEOHead } from '@/components/SEOHead';
import { BlogList } from '@/components/BlogList';
import { BlogPost } from '@/components/BlogPost';
import { PortoAirportTransferPage } from '@/components/PortoAirportTransferPage';

const HomePage = () => {
  return (
    <>
      <SEOHead />
      <Header />
      <HeroMinimal />
      <CoreServices />
      <VehicleShowcase />
      <GoVipExperience />
      <FeaturedPromos />
      <BookingSectionNew />
      <GoogleReviewsSection />
      <FAQ />
      <BottomCTA />
      <Footer />
      <FloatingCTAs />
      <CookieConsent />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Localized routes */}
          <Route
            path="/:lang"
            element={
              <LanguageSync>
                <HomePage />
              </LanguageSync>
            }
          />
          <Route
            path="/:lang/privacy"
            element={
              <LanguageSync>
                <PrivacyPolicy />
              </LanguageSync>
            }
          />
          <Route
            path="/:lang/terms"
            element={
              <LanguageSync>
                <TermsConditions />
              </LanguageSync>
            }
          />
          <Route
            path="/:lang/blog"
            element={
              <LanguageSync>
                <BlogList />
              </LanguageSync>
            }
          />
          <Route
            path="/:lang/blog/:slug"
            element={
              <LanguageSync>
                <BlogPost />
              </LanguageSync>
            }
          />
          <Route
            path="/:lang/porto-airport-private-transfer"
            element={
              <LanguageSync>
                <PortoAirportTransferPage />
              </LanguageSync>
            }
          />
          <Route
            path="/:lang/tours"
            element={
              <LanguageSync>
                <ToursPage />
              </LanguageSync>
            }
          />

          {/* Admin (no localization) */}
          <Route path="/admin/bookings" element={<AdminBookings />} />
          <Route path="/admin/marketing" element={<AdminMarketing />} />
          <Route path="/admin/promos" element={<AdminPromos />} />

          {/* Short links for cards, QR codes, WhatsApp signatures, promo material */}
          <Route path="/review" element={<ShortLinkRedirect target={SHORT_LINKS.review} label="Opening Google Reviews…" />} />
          <Route path="/whatsapp" element={<ShortLinkRedirect target={SHORT_LINKS.whatsapp} label="Opening WhatsApp…" />} />
          <Route path="/book" element={<ShortLinkRedirect target={SHORT_LINKS.book} label="Opening booking form…" />} />

          {/* Backwards compatibility / fallbacks redirect to localized URL */}
          <Route
            path="/privacy"
            element={
              <LanguageSync>
                <PrivacyPolicy />
              </LanguageSync>
            }
          />
          <Route
            path="/terms"
            element={
              <LanguageSync>
                <TermsConditions />
              </LanguageSync>
            }
          />
          <Route
            path="/"
            element={
              <LanguageSync>
                <HomePage />
              </LanguageSync>
            }
          />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
